// dependencies
import moment from "moment";
import { Map } from "immutable";
import PropTypes from "prop-types";
import React, { useState } from "react";

// components
import Button from "Components/Button";

// styles
import css from "./ReportSnapshot.styl";

const ReportSnapshot = (props) => {
	const { className, snapshot } = props;
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className={`${css.main} ${className}`}>
			<div>
				{snapshot.get("session", null) === null ? (
					<div className={css.loggedOutWrapper}>
						<div title="The user was logged out when this was recorded." className={css.userLoggedOut}>
							Logged Out
						</div>
					</div>
				) : null}

				<div className={css.date}>{moment(snapshot.get("date")).format("MMMM D, YYYY h:mm a")}</div>
				<div className={`${css.type} ${css[snapshot.get("type")]}`}>{snapshot.get("type")}</div>

				{isOpen ? (
					<div className={css.snapshotDump}>
						<div className={css.prettyJSON}>{JSON.stringify(snapshot.toJS(), null, 2)}</div>
					</div>
				) : null}

				<Button onClick={() => setIsOpen(!isOpen)} className={css.viewButton}>
					{isOpen ? "Close" : "View"}
				</Button>
			</div>
		</div>
	);
};

ReportSnapshot.propTypes = {
	className: PropTypes.string.isRequired,
	snapshot: PropTypes.instanceOf(Map).isRequired,
};

export default ReportSnapshot;
